import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Navigate, Outlet, useNavigate } from "react-router-dom";
import {
  addUser,
  addBanners,
  addSettings,
  addPickupAddresses,
  addAppData,
  addChannel,
  addAllNotifications,
  setBalance,
} from "../app/slices";
import { useApi } from "@/";
import { LoadingScreen } from "@/components";

const ProtectedRoute = ({ requiredPermission }) => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state?.user?.user);
  const navigate = useNavigate();
  const { callApi } = useApi();
  const token = localStorage.getItem("token");

  const [authLoading, setAuthLoading] = React.useState(true); // 🔥 NEW — internal gate

  const authUser = async () => {
    try {
      const res = await callApi("/common/authMe", "POST");

      if (!res.success) {
        navigate("/login");
        return;
      }

      if (res?.data?.needsRefresh) {
        const res = await callApi("/common/refresh-token", "POST", {
          token: localStorage.getItem("refreshToken"),
        });

        console.log("RefreshToken response", res);

        if (res?.success) {
          localStorage.setItem("token", res?.data?.token);
          window.location.reload();
        } else {
          alert("Your Session has expired, Please log in again.");
        }
      }

      const config = res?.data?.config || {};
      dispatch(addAppData(config?.app));
      dispatch(addUser(res?.data?.user));
      document.cookie = `userId=${res?.data?.user?._id}; path=/; max-age=86400`;
      dispatch(addBanners(config?.banners));
      dispatch(addSettings(config?.settings));
      dispatch(addPickupAddresses(config?.pickupAddress));
      dispatch(addChannel(config?.userChannels));
      dispatch(addAllNotifications(config?.notifications));
      dispatch(setBalance(config?.walletBalance));

      if (res?.data?.needsRefresh) {
        const response = await callApi("/common/refresh-token", "POST", {
          token: localStorage.getItem("refreshToken"),
        });
        if (!response.success) return navigate("/login");
        localStorage.setItem("token", response.data?.token);
      }

      setAuthLoading(false); // 🔥 mark auth complete
    } catch (err) {
      navigate("/login");
    }
  };

  useEffect(() => {
    if (!user && token) {
      authUser();
    } else {
      setAuthLoading(false);
    }
  }, [user]);

  /* 🔥 AUTH BLOCKER: don't render child page until auth is done */
  if (authLoading) return <LoadingScreen />;

  if (
    requiredPermission &&
    user?.role === "Customer-Employee" &&
    !user.permissions.includes(requiredPermission)
  ) {
    return <Navigate to="/unauthorizedUser" />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
